// @flow

import { type IncomingPayment } from './types';

export function getMustRedirectAfterPayment(incomingPayment: IncomingPayment): boolean {
  if (incomingPayment.v2 && incomingPayment.v2.redirect)
    return !!incomingPayment['v2']['redirect']['must_redirect_after_payment'];

  return !!incomingPayment['must_redirect_after_payment'];
}
